module.exports = __webpack_public_path__ + "assets/re_inspection.80c07c7c.svg";